import { type SvgProps, SvgWrapper } from '../utils';
export function PersonIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M15 14.25C16.2598 14.25 17.4676 14.7508 18.3584 15.6416C19.2492 16.5324 19.75 17.7402 19.75 19V21C19.75 21.4142 19.4142 21.75 19 21.75C18.5858 21.75 18.25 21.4142 18.25 21V19C18.25 18.138 17.9073 17.3116 17.2979 16.7021C16.7264 16.1307 15.9644 15.7937 15.1611 15.7539L15 15.75H9C8.13805 15.75 7.31164 16.0927 6.70215 16.7021C6.09266 17.3116 5.75 18.138 5.75 19V21C5.75 21.4142 5.41421 21.75 5 21.75C4.58579 21.75 4.25 21.4142 4.25 21V19C4.25 17.7402 4.7508 16.5324 5.6416 15.6416C6.5324 14.7508 7.74022 14.25 9 14.25H15Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C14.6234 2.25 16.75 4.37665 16.75 7C16.75 9.62335 14.6234 11.75 12 11.75C9.37665 11.75 7.25 9.62335 7.25 7C7.25 4.37665 9.37665 2.25 12 2.25ZM12 3.75C10.2051 3.75 8.75 5.20507 8.75 7C8.75 8.79493 10.2051 10.25 12 10.25C13.7949 10.25 15.25 8.79493 15.25 7C15.25 5.20507 13.7949 3.75 12 3.75Z"
      />
    </SvgWrapper>
  );
}
